import { getEnv } from '../helpers/getEnv';
import axios from 'axios';

/**
 * Get the Report Builder URL depending on the environment variables.
 * If the REACT_APP_REPORTS_URL is set, use that, otherwise use the {REACT_APP_API_URL}/report-builder
 * @returns {string} - Report Builder URL to use
 */
export const getReportBuilderUrl = (): string => {
  const reportBuilderUrl = getEnv('REACT_APP_REPORTS_URL');
  if (reportBuilderUrl) {
    return reportBuilderUrl;
  }
  return `${getEnv('REACT_APP_API_URL')}/report-builder`;
};

export const reportBuilderApi = axios.create({
  baseURL: getReportBuilderUrl(),
});
